import type { PresentedRelease } from '~~/shared/schemas/changelog'

type ChangelogStatus = {
  autoDisplayEnabled: boolean
  reason: 'normal' | 'forced-critical'
  releases: PresentedRelease[]
}

export function useChangelog() {
  const requestFetch = useRequestFetch() as typeof morningFetch
  const status = useState<ChangelogStatus | null>('changelog-status', () => null)
  const dismissed = useState('changelog-dismissed', () => false)
  const saving = ref(false)
  const error = ref('')

  async function refresh() {
    status.value = await requestFetch<ChangelogStatus>('/api/changelog/status')
    dismissed.value = false
  }
  async function acknowledge() {
    const versions = status.value?.releases.map((release) => release.version) ?? []
    if (!versions.length) return
    saving.value = true
    error.value = ''
    try {
      await requestFetch('/api/changelog/acknowledge', { method: 'POST', body: { versions } })
      dismissed.value = true
      status.value = status.value ? { ...status.value, releases: [] } : null
    } catch {
      error.value = 'Impossible d’enregistrer votre lecture. Réessayez.'
    } finally {
      saving.value = false
    }
  }
  return { status, dismissed, saving, error, refresh, acknowledge }
}
